export default "__VITE_ASSET__CiTZGXLm__"